import React from 'react';
import styles from './form-page.module.scss';

import { Col, Layout, Typography, Row } from 'antd';
import { useResponsive } from "../../utils/use-responsive";
import FFLogo2025_Marine from '../../assets/images/FFLogo2025_Marine.png';

const { Content, Footer, Header } = Layout;

export const FormPage: React.FC<{
  wide?: boolean;
  displayFooter?: boolean;
  children: React.ReactNode;
}> = ( { children, displayFooter } ) => {

  const { isXs } = useResponsive();

  return (
    <div>
      <Header className={styles['header']} style={{
        backgroundColor: "white",
        borderBottom: "1px solid #DCDCDC",
        padding: "5px 16px 0",
        height: "80px"
      }}>
        <Row>
          <Col xs={{ span: 6, offset: 2 }} sm={{ span: 6, offset: 2 }} md={{ span: 6, offset: 2 }}
                lg={{ span: 6, offset: 2 }} xl={{ span: 6, offset: 4 }}>
            <div className={styles['logo']}>
              <a target="_blank" href="https://financefair.com" rel="noopener noreferrer">
                <img src={FFLogo2025_Marine} alt="Financefair Logo"/>
              </a>
            </div>
          </Col>
        </Row>
      </Header>

      <Content className={`${styles['page']}`}>
        <Col xs={{ span: 24 }} sm={{ span: 18 }} md={{ span: 18 }}
             lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
          <div className={styles['page-content']}>
            {children}
          </div>
        </Col>
      </Content>

      {displayFooter && (
        <Footer className={styles['footer']}
                style={isXs ? { backgroundColor: "white" } : undefined}
        >
          <div>
            <Typography.Text style={{ textAlign: 'center' }} type="secondary">
              Got a query? Call us on{' '}
              <a href="tel: +353 1 525 2486">
                <Typography.Text type="secondary" strong>
                  +353 1 525 2486
                </Typography.Text>
              </a>{' '}
              or email us at{' '}
              <a href="mailto:busdev@financefair.com">
                <Typography.Text type="secondary" strong>
                  busdev@financefair.com
                </Typography.Text>
              </a>
            </Typography.Text>
          </div>
          <Typography.Text style={{ textAlign: 'center' }} type="secondary">
            FinanceFair | 2025
          </Typography.Text>
        </Footer>
      )}
    </div>
  );
};
